import { SimulationServiceServiceException as __BaseException } from "./SimulationServiceServiceException";
export class ValidationException extends __BaseException {
    constructor(opts) {
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts
        });
        this.name = "ValidationException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ValidationException.prototype);
        this.fieldList = opts.fieldList;
    }
}
export class BadRequest extends __BaseException {
    constructor(opts) {
        super({
            name: "BadRequest",
            $fault: "client",
            ...opts
        });
        this.name = "BadRequest";
        this.$fault = "client";
        Object.setPrototypeOf(this, BadRequest.prototype);
    }
}
export class InvalidCoordinates extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidCoordinates",
            $fault: "client",
            ...opts
        });
        this.name = "InvalidCoordinates";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidCoordinates.prototype);
        this.coord = opts.coord;
    }
}
export class InvalidState extends __BaseException {
    constructor(opts) {
        super({
            name: "InvalidState",
            $fault: "client",
            ...opts
        });
        this.name = "InvalidState";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidState.prototype);
        this.stateFound = opts.stateFound;
        this.stateExpected = opts.stateExpected;
    }
}
export class NoSuchResource extends __BaseException {
    constructor(opts) {
        super({
            name: "NoSuchResource",
            $fault: "client",
            ...opts
        });
        this.name = "NoSuchResource";
        this.$fault = "client";
        Object.setPrototypeOf(this, NoSuchResource.prototype);
        this.resourceType = opts.resourceType;
        this.resourceId = opts.resourceId;
    }
}
export const GridConnectionType = {
    HV_LINE: "HV_LINE",
    SUBSTATION: "SUBSTATION",
};
export const ModelWt = {
    V126: "V126",
};
export const Optimization = {
    COMBINED: "COMBINED",
    LCOE: "LCOE",
    SOLAR: "SOLAR",
    STABILITY: "STABILITY",
    WIND: "WIND",
};
export const SimulationState = {
    COMPUTING: "COMPUTING",
    CREATED: "CREATED",
    ERROR: "ERROR",
    READY: "READY",
};
